<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html, body {
  padding: 0;
  margin: 0;
}
.nav {
  margin-bottom: 130px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue